export const CHANGE_PASSWORD_REQUEST   = 'CHANGE_PASSWORD_REQUEST'
export const CHANGE_PASSWORD_SUCCESS   = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAIL      = 'CHANGE_PASSWORD_FAIL'
export const CHANGE_PASSWORD_RESET      = 'CHANGE_PASSWORD_RESET'

export const SEND_EMAIL_VERIFICATION_REQUEST   = 'SEND_EMAIL_VERIFICATION_REQUEST'
export const SEND_EMAIL_VERIFICATION_SUCCESS   = 'SEND_EMAIL_VERIFICATION_SUCCESS'
export const SEND_EMAIL_VERIFICATION_FAIL      = 'SEND_EMAIL_VERIFICATION_FAIL'